import * as styles from "./Tag.css";
import { Link as ILink } from "~/sanity/types";
import Link from "./Link";
import { PropsWithChildren } from "react";
import { Paragraph } from "./Paragraph";

export type TagProps = styles.TagVariants & {
  label?: string;
  link?: ILink & { slug?: string };
};

export const Tag = ({
  theme = "dark",
  size = "md",
  link,
  label,
  ...props
}: TagProps) => {
  return (
    <>
      {label &&
        (link ? (
          <Link
            {...link}
            className={styles.tag({
              theme: theme,
              size: size,
            })}
          >
            <Paragraph className={styles.text} size={size}>
              {label}
            </Paragraph>
          </Link>
        ) : (
          <div
            style={{ pointerEvents: "none" }}
            className={styles.tag({
              theme: theme,
              size: size,
            })}
          >
            <Paragraph className={styles.text} size={size}>
              {label}
            </Paragraph>
          </div>
        ))}
    </>
  );
};
